import { fetchApi } from "infrastructure/api";
import { ApiRoutes } from "consts/enpoints/api";
import { RoleName } from "consts/auth";
import { when } from "util/support";
import type { NewPasswordCredentials, TwoFactorVerify, UserCredentials } from "features/auth/types";
import { getOnboardingUserById } from "features/ecommerce/api";
import { getUserById } from "features/users/api";
import AuthException from "./exceptions";
import { getRoleName, getUserId } from "./helpers";

export const getUser = (apiStrategy = new Map([
  [RoleName.OnboardingE, getOnboardingUserById],
  [RoleName.OnboardingO, getOnboardingUserById]
])) => () => {
  const [userId, roleName] = [getUserId(), getRoleName()];

  if (!userId || !roleName) {
    return Promise.reject(
      new AuthException(
        `User ID or Role is not provided`,
        {}
      )
    );
  }

  return when(
    apiStrategy.has(roleName),
    () => apiStrategy.get(roleName)!(userId),
    () => getUserById(userId)
  );
};

export const login = (body: UserCredentials) =>
  fetchApi(ApiRoutes.PostLogin, {
    method: "post",
    body,
  });

export const logout = () =>
  fetchApi(ApiRoutes.PostLogout, {
    method: 'post'
  });

export const verify = (body: TwoFactorVerify) =>
  fetchApi(ApiRoutes.PostVerify2FA, {
    method: 'post',
    body
  });

export const resend2FACode = () =>
  fetchApi(ApiRoutes.PostResend2FACode, {
    method: 'post'
  });

export const recover = (body: Pick<UserCredentials, 'email'>) =>
  fetchApi(ApiRoutes.PostRecover, {
    method: 'post',
    body
  });

export const newPassword = (body: NewPasswordCredentials) =>
  fetchApi(ApiRoutes.PostNewPassword, {
    method: 'post',
    body
  });
